import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Mousewheel, Scrollbar } from "swiper";
import clsx from "clsx";
import { ICategoryOption, IOption, ISwatchContent } from "../../types/customizer";
import SwatchOption from "../SwatchOption";
import "../../../../node_modules/swiper/swiper.min.css";

import './sizeFilter.scss';
import { useResizeDetector } from "react-resize-detector";
import { useRingCustomizerContext } from "../../context/RingCustomizerContext";

export interface ISizeFilterProps {
  content: ISwatchContent;
  onChange: (updated: any) => void;
  innerTab?: number;
  isFetching: boolean;
}

const SizeFilter = ({ content, onChange, isFetching, innerTab = 1 }:ISizeFilterProps) => {
  const { subpath } = useRingCustomizerContext();
  const { fieldType } = content;
  const options: Array<IOption> = content.options as Array<IOption>;

  const { width, ref } = useResizeDetector();
  let timeoutId: any = null;
  const [isChanging, setIsChanging] = useState('');
  const [swiper, setSwiper] = useState<any>(null);
  const [activeIndex, setActiveIndex] = useState(() => {
    const index = options.findIndex(item => item.selected);
    return index;
  });

  useEffect(() => {
    if (!isFetching) {
      setIsChanging('');
    }
  }, [isFetching]);

  useEffect(() => {
    const index = options.findIndex(item => item.selected);
    setActiveIndex(index);
  }, [options]);

  // useEffect(() => {
  //   swiper?.slideToLoop(activeIndex);
  // }, [activeIndex, swiper, options.length]);

  useEffect(() => {
    if (width) {
      ref.current.style.width = `${width + 1}px`;
      setTimeout(() => {
        ref.current.style.width = `${width}px`;
      }, 100);
    }
  }, [!!width]);

  const handleChange = (updatedObj: Record<string, string>) => {
    setIsChanging(Object.values(updatedObj)[0]); // used for deseclecting old one till response recieved
    onChange(updatedObj);
  };

  // const handleSlideChange = (e: any) => {
  // /**
  //  * On Css mode while slider, onSlideChange trigger everytime till animation ends, So call timeout after 500ms
  //  */
  //   clearTimeout(timeoutId);
  //   timeoutId = setTimeout(() => {
  //     const index = e.realIndex;
  //     if (index !== null && index !== undefined && index !== activeIndex) {
  //       setActiveIndex(index);
  //       const option = options[index];
  //       handleChange({ [fieldType]: option.sku });
  //     }
  //   }, 500);
  // };

  const handleSizeChange = (index: number) => () => {
    if (index !== null && index !== undefined && index !== activeIndex) {
      setActiveIndex(index);
      const option = options[index];
      handleChange({ [fieldType]: option.sku });
    }
  }

  return (
    <div className="tw-flex tw-justify-center tw-pb-2 swatch-filter-border" style={{ height: `calc(100% - ${45 * innerTab}px)` }} ref={ref}>
      <div className="tw-w-full sm:tw-w-full tw-px-4">
        {['revolution', 'stonebrook-jewelry', 'foundry'].includes(subpath) && (
          <div className="tw-mt-4 tw-mb-4 tw-p-3 tw-bg-gray-100 tw-rounded-md tw-text-sm tw-text-gray-600 tw-max-w-full tw-overflow-hidden tw-box-border">
            <p className="tw-font-semibold tw-flex tw-items-center tw-gap-1">
              <svg className="tw-w-4 tw-h-4" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
              </svg>
              Not sure of your ring size?
            </p>
            <p className="tw-mt-1">No need to decide yet — leave the default size selected and click Finish Your Design. In the next step, you'll have the option to add <strong>Free Ring Sizers</strong>.</p>
          </div>
        )}
        <div className="tw-mb-2 tw-mt-5 xs:tw-text-center sm:tw-text-left">
          <div className="tw-inline-block xs:tw-w-4/6 sm:tw-w-4/6 tw-text-base">Select your finger size</div>
        </div>
        <div className="tw-overflow-y-auto tw-overflow-x-hidden tw-pb-2" ref={ref}>
          {/*
            1. Removed slideToClickedSlide as it interferes with natural scrolling
            2. Removed grabCursor as it's not needed for scroll behavior
            3. Removed resistance to allow natural scrolling to edges
            4. Enhanced freeMode configuration with momentum settings
          */}
          <Swiper
            onSwiper={setSwiper}
            slidesPerView="auto"
            initialSlide={activeIndex}
            centeredSlides={true}
            slideToClickedSlide={false}
            grabCursor={false}
            resistance={false}
            loop={false}
            cssMode={false}
            spaceBetween={8}
            freeMode={{
              enabled: true,
              momentum: true,
              momentumRatio: 1,
              momentumVelocityRatio: 1
            }}
            // onSlideChange={handleSlideChange}
            scrollbar={{
              hide: false, // makes scrollbar always visible
              draggable: true
            }}
            mousewheel={{
              forceToAxis: true,
              sensitivity: 1
            }}
            modules={[Mousewheel, FreeMode, Scrollbar]}
          >
            {options.map((option: IOption | ICategoryOption, index: number) =>
              <SwiperSlide key={index} className={clsx('size-slide tw-cursor-pointer', { 'active-slide': index === activeIndex })} onClick={handleSizeChange(index)}>
                {option.name}
              </SwiperSlide>)
            }
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default SizeFilter;
